import { Offcanvas } from "bootstrap";
import { ErrorSwal, ajaxErrorAlert, ajaxPost } from "./js/utils";

$(document).on("click", ".hamburger", (e) => {
  $(e.currentTarget).toggleClass("is-active");
  $(e.currentTarget).closest("div").find(".hamburger-menu").toggleClass("show");

  const offcanvasElement = document.querySelectorAll(
    "#main-navbar-offcanvas",
  )[0];
  let offcanvas = Offcanvas.getInstance(offcanvasElement);

  if (!offcanvas) {
    offcanvas = new Offcanvas(offcanvasElement);
  }

  offcanvas.toggle();
  offcanvasElement.addEventListener("hidden.bs.offcanvas", function () {
    $(".hamburger").removeClass("is-active");
    $(".hamburger-menu").removeClass("show");
  });
});

$(".offcanvas-body a").on("click", function (e) {
  const offcanvasElement = document.querySelectorAll(
    "#main-navbar-offcanvas",
  )[0];
  let offcanvas = Offcanvas.getInstance(offcanvasElement);
  if (!offcanvas) {
    offcanvas = new Offcanvas(offcanvasElement);
  }
  offcanvas.hide();
});

$("#feedbackForm").on("submit", (e) => {
  e.preventDefault();
  const form = $(e.target);
  ajaxPost("", form.serializeArray(), form)
    .then(() => {
      ErrorSwal.fire({
        icon: "success",
        text: "Əməliyyat uğurla tamamlandı",
        timer: 1000,
      }).then(() => {
        window.location.reload();
      });
    })
    .catch((errors) => {
      ajaxErrorAlert(errors, form);
    });
});
